import { FilterInstruction } from "./filter-instruction.enum";


export class Condition {
    public value: string;
    public instruction: FilterInstruction | string;
}
